import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { ContextualHelpBox } from 'components/ContextualHelp/ContextualHelp.style'

export const CollapseWrapper = styled.div`
  .ant-collapse {
    background: transparent;
    border: none;
  }

  .ant-collapse-item {
    border: none;
  }

  .ant-collapse-header {
    color: ${themeColor('primaryPurple')} !important;
    font-size: 12px;
    font-weight: normal;
    padding: 8px 0 !important;
  }

  .caret-icon {
    display: inline-flex;
    align-items: center;
    margin-left: 4px;
    transition: transform 0.2s;

    svg {
      color: ${themeColor('primaryPurple')};
    }
  }

  .ant-collapse-item-active .caret-icon {
    transform: rotate(180deg);
  }

  .ant-collapse-content {
    border: none;
  }

  .ant-collapse-content-box {
    padding: 0 !important;
  }

  ${ContextualHelpBox} {
    margin-top: 0;
  }
`

export const HelpButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 8px;
`
